import { useEffect } from 'react'
import { NavigationType, Outlet, useLocation, useNavigationType } from 'react-router-dom'
import { Footer } from './Footer'
import { Header } from './Header'
import { LocalFileSelectionFeedback } from '../tools/LocalFileSelectionFeedback'

function RouteScrollManager() {
  const location = useLocation()
  const navigationType = useNavigationType()

  useEffect(() => {
    if (location.hash) {
      document.getElementById(location.hash.slice(1))?.scrollIntoView()
      return
    }

    if (navigationType !== NavigationType.Pop) window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [location.hash, location.pathname, navigationType])

  return null
}

export function SiteLayout() {
  return (
    <div className="site-frame">
      <RouteScrollManager />
      <LocalFileSelectionFeedback />
      <a className="skip-link" href="#main-content">Skip to content</a>
      <Header />
      <main id="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
